 	// The module cache
 	var installedModules = {};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].Imports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			Imports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.Imports, module, module.Imports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the Imports of the module
 		return module.Imports;
 	}


 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony Imports
 	__webpack_require__.d = function(Imports, name, getter) {
 		if(!__webpack_require__.o(Imports, name)) {
 			Object.defineProperty(Imports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// define __esModule on Imports
 	__webpack_require__.r = function(Imports) {
 		Object.defineProperty(Imports, '__esModule', { value: true });
 	};

 	// getDefaultImport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleImports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";


 	// Load entry module and return Imports
 	return __webpack_require__(__webpack_require__.s = 80);
